// extracted by mini-css-extract-plugin
export default {"process":"KoshaMsPage_process__mJxoN","consulting_process":"KoshaMsPage_consulting_process__7H4DX"};